export const iconFontAwesomeFoodBeverageStroopwafel = (
	<i className="fa-solid fa-stroopwafel"></i>
);
